export const isNativeAppAtClose = ({ currentWindow = window } = {}) =>
  Boolean(
    currentWindow.android || currentWindow.webkit?.messageHandlers,
  );

export const redirectAfterEndChat = ({
  currentWindow = window,
  isNativeApp,
  redirectUrl,
}) => {
  const navigationWindow = isNativeApp
    ? currentWindow
    : currentWindow.top || currentWindow;

  navigationWindow.location.href = redirectUrl;
};
